import { QueryClient } from '@tanstack/react-query';

/**
 * The single app-wide React Query client. Exported from its own module (rather than created inline
 * in main.tsx) so non-React code — e.g. the session store's "View as Rep" logic — can reset the
 * cache when the effective identity changes.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 60_000 },
  },
});
